module.exports = __webpack_public_path__ + "img/hopeforall.21983e12.png";